<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/02c_Borghi_Santa-Severina-new.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Borghi storici</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a class="active">Borghi storici</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il paesaggio calabrese è contraddistinto dalla presenza di borghi di raro fascino, 
            il più delle volte in posizione dominante a guardia dei percorsi fluviali e delle coste. Tra i borghi più belli d’Italia si annoverano Rocca Imperiale, 
            con l’imponente castello federiciano che affaccia sullo Jonio, Oriolo e Morano Calabro, abbarbicati alle pendici del Pollino, 
            e Civita il paese di origini arbëreshe sulle gole del Raganello. Sul versante ovest del Parco, invece, vi sono Aieta, l’antica Aieta Vetere degli 
            Enotri e Buonvicino sul parco marino della Riviera dei Cedri. Fra il Pollino e la Sila, domina il paesaggio l’angioina Altomonte e più a sud s’incontrano, 
            ad ovest, Fiumefreddo Bruzio, il centro fortificato dove ha dimorato Gioacchino da Fiore, e verso est, Caccuri, il borgo sul fiume Neto, e Santa Severina, 
            la città bizantina e normanna che domina il golfo di Crotone.
            <br>
            <br>
            Alle pendici della Sila Piccola si trova Taverna, lo storico paese del pittore Mattei Preti (Bandiera arancione del Touring), e poi, 
            superato l’istmo, con Tiriolo a guardia dei due mari, si raggiunge Badolato, il “presepe” della Calabria jonica; da qui si approda in breve a Stilo, 
            la Città di Tommaso Campanella e della “Cattolica”, vero e proprio simbolo della Calabria bizantina. Sulla costa tirrenica è Tropea a segnare magnificamente 
            il paesaggio marino e più a sud, Scilla con il suo villaggio di pescatori “Chianalea”. Dall’altra parte, invece, attraversando il Parco dell’Aspromonte, 
            ecco che s’incontra Gerace, la città medievale delle cento chiese e poi, ormai in vista della Sicilia, si raggiunge Bova, la “capitale” dell’area grecanica 
            sulla Fiumara dell’Amendolea segnata dalla presenza di Geositi di raro fascino.                        
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>